import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/activation-readiness-review/page.tsx");
